var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg"},[_c('CmpControlAmplifier',{attrs:{"data_list":_vm.listactive,"mode":'Done'},on:{"clicked":_vm.getAmpliControlCmpCallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }